import Vue from 'vue'
import Vuex from 'vuex'
import initialState from '@/store/initial-state'

// Actions
import consumptionActions from '@/store/actions/consumption'
import cubeActions from '@/store/actions/cube'
import deviceManagerActions from '@/store/actions/device-manager'
import downloadsActions from '@/store/actions/downloads'
import globalActions from '@/store/actions/global'
import reemActions from '@/store/actions/reem'

// Mutations
import consumptionMutations from '@/store/mutations/consumption'
import cubeMutations from '@/store/mutations/cube'
import cubeFilterMutations from '@/store/mutations/cubeFilter'
import deviceManagerMutations from '@/store/mutations/device-manager'
import downloadsMutations from '@/store/mutations/downloads'
import globalMutations from '@/store/mutations/global'
import reemMutations from '@/store/mutations/reem'

// Getters
import consumptionGetters from '@/store/getters/consumption'
import cubeGetters from '@/store/getters/cube'
import deviceManagerGetters from '@/store/getters/device-manager'
import downloadsGetters from '@/store/getters/downloads'
import globalGetters from '@/store/getters/global'
import reemGetters from '@/store/getters/reem'
import cubeFilterGetters from '@/store/getters/cubeFilter'

Vue.use(Vuex)

export default new Vuex.Store({
  state: initialState,
  actions: {
    ...consumptionActions,
    ...cubeActions,
    ...downloadsActions,
    ...deviceManagerActions,
    ...globalActions,
    ...reemActions,
  },
  mutations: {
    ...consumptionMutations,
    ...cubeFilterMutations,
    ...cubeMutations,
    ...downloadsMutations,
    ...deviceManagerMutations,
    ...globalMutations,
    ...reemMutations,
  },
  getters: {
    ...consumptionGetters,
    ...cubeGetters,
    ...deviceManagerGetters,
    ...downloadsGetters,
    ...globalGetters,
    ...reemGetters,
    ...cubeFilterGetters,
  },
})
